import React from "react";
import { DataTableCell } from "../../general/DataTable/DataTableCell";
import { accountingNumberFormatter } from "../../../common/helpers/number";
import { TrialBalancePeriod } from "../../../common/contracts/accounting-reports";
import { TrialBalanceTableDrillDown } from "./TrialBalanceTableDrillDownl";

interface Props {
    value: number;
    accountCode: string;
    period: TrialBalancePeriod;
    isSummary?: boolean;
}

export const TrialBalanceTableValueCell: React.FC<Props> = ({
    value,
    accountCode,
    period,
    isSummary,
}) => {
    const displayValue = accountingNumberFormatter(value);

    return (
        <DataTableCell>
            {!isSummary && value ? (
                <TrialBalanceTableDrillDown
                    accountCode={accountCode}
                    period={period}
                >
                    {displayValue}
                </TrialBalanceTableDrillDown>
            ) : (
                displayValue
            )}
        </DataTableCell>
    );
};
